import React from 'react';

import CategoryQuotaList  from 'components/Tvendo/Sale/QuotaBPartner/Colgate/CategoryQuota/List.js';

export default function () {
  return <CategoryQuotaList  />;
}